import * as React from "react";
import { useTranslation } from "react-i18next";

import styles from "./BurnoutButtery.module.scss";

import { burnoutButteryHead, burnoutButteryMan } from "assets/image";

const BurnoutButtery = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.title}>
        <img
          className={styles.titleImage}
          src={burnoutButteryHead}
          alt="Head"
        />
        {t("Docs.BurnoutButtery.Title")}
      </div>
      <div className={styles.blockContainer}>
        <div className={styles.column}>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block1.TextBlue")}
            </span>
            {t("Docs.BurnoutButtery.Blocks.Block1.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block2.TextBlue")}
            </span>
            {t("Docs.BurnoutButtery.Blocks.Block2.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block3.TextBlue")}
            </span>
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block4.TextBlue")}
            </span>
            {t("Docs.BurnoutButtery.Blocks.Block4.Text")}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block5.TextBlue")}
            </span>
            {t("Docs.BurnoutButtery.Blocks.Block5.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block6.TextBlue")}
            </span>
            {t("Docs.BurnoutButtery.Blocks.Block6.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutButtery.Blocks.Block7.TextBlue")}
            </span>
            {t("Docs.BurnoutButtery.Blocks.Block7.Text")}
          </div>
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img
          className={styles.image}
          src={burnoutButteryMan}
          alt="Man with problems"
        />
      </div>
    </div>
  );
};

export default BurnoutButtery;
